import { api } from "../../api";

export const adminApi = api.injectEndpoints({
    endpoints: (build) => ({
        onLogin: build.mutation({
            query: ({ data }) => ({
                url: "/login/",
                method: "POST",
                body: data,
            }),
        }),
        fetchUser: build.query({
            query: () => ({
                url: "admin-module/get-user-detail/",
                method: "GET",
                credentials: "include", // Include cookies for session-based auth
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useOnLoginMutation, useFetchUserQuery } = adminApi;
